import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { Consumer, Provider } from '../components/Context';

var Theme = function (_Component) {
  _inherits(Theme, _Component);

  function Theme() {
    _classCallCheck(this, Theme);

    return _possibleConstructorReturn(this, (Theme.__proto__ || _Object$getPrototypeOf(Theme)).apply(this, arguments));
  }

  _createClass(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return React.createElement(
        Consumer,
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : React.createElement(
            Provider,
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(Component);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
export default Theme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/modal-dialog/node_modules/@atlaskit/theme/dist/esm/components/Theme.js
// module id = 525
// module chunks = 0